export const getRouterName = (state) => {
  return state.router;
};
